import { instance } from "./axios-service";


export function doUpload(file: File, url: string, onUploadProgress) {
    const formData = new FormData();
    formData.append("file", file);
    return instance.post(url, formData, onUploadProgress);
}

export function uploadPrevisiteFile(file: File, id: string, onUploadProgress) {
    return doUpload(file, "/files/upload/previsitefile/" + id, onUploadProgress);
}

export function downloadPrevisiteFile(id: string) {
    return instance.get("/files/download/previsitefile/" + id, {
        responseType: "blob",
        headers: {
            Accept: "*/*",
        },
    });
}

export function getPrevisiteFileInfo(laverieId: string) {
    return instance.get("/files/info/previsitefile/" + laverieId);
}

export function uploadBonInstallFile(file: File, laverieId: string, onUploadProgress) {
    return doUpload(file, "/files/upload/boninstall/" + laverieId, onUploadProgress);
}

export function downloadBonInstallFile(laverieId: string) {
    return instance.get("/files/download/boninstall/" + laverieId, {
        responseType: "blob",
        headers: {
            Accept: "*/*",
        },
    });
}

export function getBonInstallFileInfo(laverieId: string) {
    return instance.get("/files/info/boninstall/" + laverieId);
}